import TabLayout from "layout/TabLayout";
import { Trial_Status, TrialHeaderQuery } from "@generated/graphql";
import InfoTab from "./InfoTab";
import ResultTab from "./ResultTab";

interface TestingContentProps {
  trial: TrialHeaderQuery["trial"] | undefined;
  isCreate: boolean;
}

const TestingContent = ({ trial, isCreate }: TestingContentProps) => {
  const TABS = [
    {
      title: "Общая информация",
      id: "info",
      component: <InfoTab />,
    },
    {
      title: "Результаты",
      id: "result",
      component: <ResultTab />,
      disabled: isCreate || trial?.status !== Trial_Status.Completed,
    },
  ];

  return (
    <TabLayout
      tabs={TABS}
      defaultTab='info'
    />
  );
};

export default TestingContent;
